import { gql } from "@apollo/client";

export const InfrastructureSelect = gql`
    query InfrastructureSelect($id: ID!) {
        installedBaseNode (id: $id){
            id
            key
            title
            assetCount
            childrenNodeCount
            nodeType {
                id
                key
                name
            }
            pathNodes {
                id
                title
            }
        }
    }
`;
